module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAVBAMAAABMGyhsAAAAMFBMVEUAAAB4eHiAgIB9fX2AgIB+fn59fX1+fn5+fn5/f39+fn59fX1+fn5+fn5+fn5+fn72T/zDAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAr0lEQVQY02Ow2o0MdhkwvP+PAi4woPL/fyBH4N8Ul/s/3I/4/3R0/3/EE6TiX0H9R84G+wIG9v8JLGAtZfEL5AriGdb//cvECBaYkB9Q71AvoPn/O7vAeZDABTuG+wrrNzLEf+IJmA8S+MzK8p/h/L8CrgnaCfUgge8MnL8Zfv9/wOXAwOAPEvjFoP+T+QsjgzVDeQE/SOCfS/9P92+O5i/c/3/1+UAVz2GEGHqYAgDGAgQevWLIsQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/f-visa.png
// module id = 753
// module chunks = 0